import { Page } from "../../../../../-components/Page"
import { PageLayoutGroup33_66 } from "../../../../../-components/Page/PageLayoutGroup33_66"
import { FeedView } from "./FeedView"
import { SearchableFeedListForUserStack } from "./SearchableFeedListStack"
import { FeedPostsForUserList } from "./FeedPostCardList"
import { useBreakpoints } from "../../../../../utils/use-breakpoints"
import { ChatHeaderGroup } from "@/routes/-components/chat/ChatHeaderGroup"
import { Stack } from "@mantine/core"

interface Props {
  chatId?: number
}

export function FeedOverviewPage({ chatId }: Props) {
  const { xs, sm, md } = useBreakpoints()

  const smallLayout = xs || sm || md

  const [subscribed, setSubscribed] = React.useState<boolean>(false)

  const leftPanelContent = (
    <SearchableFeedListForUserStack
      subscribed={subscribed}
      setSubscribed={setSubscribed}
      smallLayout={smallLayout}
    />
  )

  const rightPanelContent = chatId ? (
    <FeedView chatId={chatId} />
  ) : (
    <FeedPostsForUserList subscribed={subscribed} />
  )

  return (
    <Page
      crumbOverride={
        chatId && smallLayout
          ? () => <ChatHeaderGroup key={chatId} chatId={chatId} />
          : undefined
      }
      navGroupProps={{
        wrap: "nowrap",
        w: "100%",
        style: { overflow: "hidden" },
      }}
    >
      {smallLayout ? (
        chatId === undefined ? (
          <Stack h="100%" gap="xs">
            {leftPanelContent}
          </Stack>
        ) : (
          rightPanelContent
        )
      ) : (
        <PageLayoutGroup33_66
          leftPanelContent={leftPanelContent}
          rightPanelContent={rightPanelContent}
        />
      )}
    </Page>
  )
}
